export default {

  //遍历删除指定字符串开头的缓存
  removePrefix(prefix){
    let len = prefix.length;
    if (len <= 0) return false ;
    for (var i = 0; i < localStorage.length; i++){
      if (localStorage.key(i).substring(0,len) === prefix) {
        localStorage.removeItem(localStorage.key(i))
      }
    }
  },

  //删除编辑器的缓存
  removeCodeCache(){
    //localStorage 满了 怎么办？先把没用的删了吧
    this.removePrefix("problemset-");
    this.removePrefix("Evaluating-");
  },

  setCache(key,value){
    try {
      localStorage.setItem(key,value);
    } catch (e) {
      if (e.code === QUOTA_EXCEEDED_ERR_CODE) {
        //localStorage 满了 怎么办？先把没用的删了吧
        this.removeCodeCache();
        localStorage.setItem(key,value);
      }
    }
  },

  //清除用户登录数据
  clearLoginStore(){
    localStorage.removeItem("utoken")
  },

}



//////////////////
// WEBPACK FOOTER
// ./static/utils/localStorageUtil.js
// module id = 2xBS
// module chunks = 36